import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PRIVATE_API } from "../../api/apiIndex";

const initialState = {
  data: null,
  role: "CLIENT",
  error: "",
  status: "idle",
  user: null,
  getStatus: "idle",
  updateStatus: "idle",
};

export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (role, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.get(`/user/getByRole/${role}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const updateUser = createAsyncThunk(
  "users/updateUser",
  async (userData, { rejectWithValue }) => {
    try {
      const { id, data } = userData;
      const response = await PRIVATE_API.put(`/user/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.reponse.data : error);
    }
  }
);

export const getUser = createAsyncThunk(
  "users/getUser",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.get(`/user/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.reponse.data : error);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.delete(`/user/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.reponse.data : error);
    }
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    clearUser: (state) => {
      state.user = null;
      state.getStatus = "idle";
      state.updateStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    // fetch users
    builder
      .addCase(fetchUsers.pending, (state, action) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = "success";
        state.error = "";
        state.data = action.payload.data;
        state.role = action.payload.role;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = "failed";
        // console.log(action);
        state.error = action.payload.message;
      })
      // Update User
      .addCase(updateUser.pending, (state, action) => {
        state.updateStatus = "loading";
        state.error = "";
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.updateStatus = "success";
        state.error = "";
        state.data = state.data?.map((user) =>
          user?._id === action?.payload?.data?._id ? action.payload.data : user
        );
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.updateStatus = "failed";
        state.error = action.payload.message;
      })

      // Get a user
      .addCase(getUser.pending, (state, action) => {
        state.getStatus = "loading";
        state.error = "";
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.error = "";
        state.user = action.payload.data;
        state.getStatus = "success";
      })
      .addCase(getUser.rejected, (state, action) => {
        state.getStatus = "failed";
        state.error = action.payload.message;
      })
      // Delete user
      .addCase(deleteUser.pending, (state, action) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.status = "success";
        state.error = "";
        state.data = state.data.filter(
          (user) => user._id !== action.payload.data
        );
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
      });
  },
});

export const { clearUser } = usersSlice.actions;
export const getUsers = (state) => state.users.data;
export const getUsersStatus = (state) => state.users.status;
export const getUsersRole = (state) => state.users.role;

export const getAUser = (state) => state.users.user;
export const getGetUserStatus = (state) => state.users.getStatus;

export const getUpdateUserStatus = (state) => state.users.updateStatus;

export const getUserError = (state) => state.users.error;

export default usersSlice.reducer;
